import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: any) => ({
  container: {
    background: "#ffffff",
    border: "1px solid #e6e6e6",
    borderRadius: 3,
    display: "flex" as "flex",
    flexDirection: "column" as "column",
    minHeight: "100%",
    width: "100%"
  },
  label: {
    "& > span": {
      "&:last-child": {
        margin: 0
      },
      display: "block" as "block",
      margin: "0 0 12px"
    },
    borderBottom: "1px solid #e6e6e6",
    color: "#545454",
    fontWeight: "bold" as "bold",
    margin: "0 0 12px",
    padding: "12px 24px"
  },
  question: {
    "& .checkbox-group": {},
    "& .dropdown": {
      margin: "12px"
    },
    "& .range-slider": {
      margin: "0 auto",
      padding: "0px 35px 38px",
      [theme.breakpoints.up("md")]: {
        padding: "20px 35px 38px"
      }
    },
    display: "flex" as "flex",
    flexDirection: "column" as "column",
    flexGrow: 1
  },
  required: {
    "& span:last-child": {
      "&:after": {
        color: "rgba(84, 84, 84, 0.52)",
        content: '"*"',
        position: "absolute" as "absolute"
      }
    }
  }
}));

interface IProps {
  label: string;
  children: React.ReactChild;
  required?: boolean;
  userName?: string;
}

export const QuestionContainer = ({ label, children, required = false, userName = "{{ name }}" }: IProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const displayLabel = React.useMemo(() => {
    return (
      t(label, {
        firstName: userName,
        name: userName
      }) as string
    )
      .split("\n")
      .filter(part => part.trim())
      .map((part, key) => <span key={key}>{part}</span>);
  }, [label, userName]);

  const labelClassName = React.useMemo(() => {
    const classNames = [classes.label];
    if (required) {
      classNames.push(classes.required);
    }
    return classNames.join(" ");
  }, [required]);
  return (
    <div className={classes.container}>
      <div className={labelClassName}>{displayLabel}</div>
      <div className={classes.question}>{children}</div>
    </div>
  );
};
